import { render } from "./AppBadge.vue?vue&type=template&id=60a54c5a&ts=true"
import script from "./AppBadge.vue?vue&type=script&lang=ts"
export * from "./AppBadge.vue?vue&type=script&lang=ts"

import "./AppBadge.vue?vue&type=style&index=0&id=60a54c5a&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__